import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";

import Header from './header/index'
import QuestionList from "./question/questionList";
import Report from "./report/reports";

class App extends Component {
  state = { searchValue: "" }

  handleChange = (keyword) => {
    this.setState({
      searchValue: keyword
    })
  }

  render() {
    const { searchValue } = this.state;
    return (
      <div className="app">
        <Router>
          <Header handleChange={this.handleChange} />
          <Switch>
            <Route path="/help/:id" component={() => <QuestionList searchValue={searchValue} />} />
            <Route path="/reports" component={Report} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
